import React from 'react'
import { GroupWithLogo } from '../../types/Groupement'
import BaseCardList from '../ui/baseCardList'

interface FirmGroupsListProps {
  groups: GroupWithLogo[]
}

const FirmGroupsList = ({ groups }: FirmGroupsListProps) => {
  if (!groups?.length) {
    return null
  }

  return (
    <BaseCardList
      title="Nos groupements"
      items={groups.map((group) => ({
        id: group.id,
        name: group.title,
        logoUrl: group.logo.url,
        logo: null,
        link: `/cabinets/groupements/${group.slug}`,
      }))}
    />
  )
}

export default FirmGroupsList
